import { Injectable } from '@angular/core';
import { Platform, PopoverController, ToastController, ToastOptions } from '@ionic/angular';
import { TextableMessage } from './backported_types/messaging';
import { IosMessagePopoverPage } from './pages/ios-message-popover/ios-message-popover.page';
import { TextableService } from './services/textable-service.service';

interface PresentToastOptions extends ToastOptions {
  /**
   * When true, any active popovers will be dismissed when the toast is displayed
   */
  dismissPopovers?: boolean;
  /**
   * When true, any active modals will be dismissed when the toast is displayed
   */
  dismissModeal?: boolean
   /**
   * When true, heldPress gesture will be removed when the toast is displayed
   */
  removeHeldPress?: boolean
}

@Injectable({
  providedIn: 'root'
})
export class PopoverAndToastService {

  private activePopover: HTMLIonPopoverElement | undefined;

  constructor(
    private toastController: ToastController,
    private popoverController: PopoverController,
    private platform: Platform,
    private textable: TextableService,
  ) { }

  async presentToast(options: PresentToastOptions) {
    const toast = await this.toastController.create(options)
    toast.present();
    if (options.dismissPopovers && this.platform.is("ios")) {
      this.activePopover?.dismiss();
    }
    if (options.dismissModeal) {
      this.textable.modal.dismiss(); // todo bring this in to PopoverAndToastService
    }
  }

  public async dismissPopover() {
    this.activePopover?.dismiss();
  }

    /////////////////////
  //POPOVERS AND MODALS
  ////////////////////


   public async presentIOSMessagePopover(ev: Event, message: TextableMessage) {
    this.activePopover = await this.popoverController.create({
      component: IosMessagePopoverPage,
      componentProps: {
        id: message.id,
        send_status: message.send_status,
        heldMessage: message
      },
      event: ev,
      translucent: true,
    });
    await this.activePopover.present();
    await this.activePopover.onDidDismiss();
  }
}
